import React, { useContext } from 'react';
import context from '../../../../../../hoc/context/product/context';
import RichText from '../../../../../../hoc/components/rich-text';
import InformationPanel from '../../../../../../hoc/components/information-panel';

const ConfirmationHeaderBottom: React.FC = () => {
	const ctxt = useContext(context);

	return (
		<>
			{ctxt.json.pages.confirmation.header.more && (
				<InformationPanel>
					<RichText html={ctxt.json.pages.confirmation.header.more} />
				</InformationPanel>
			)}
		</>
	);
};

export default ConfirmationHeaderBottom;
